import { PointsToCashForMortgageScreen } from './PointsToCashForMortgage'
import { DestinationAccountSelectorScreen } from './DestinationAccountSelector'
import { RedemptionConfirmationScreen } from './RedemptionConfirmation'
import { SuccessConfirmationScreen } from './SuccessConfirmation'
import { MortgageAddressSelectorScreen } from './MortgageAddressSelector'
import { MortgageAddressScreen } from './MortgageAddress'
export const PointsToCashForMortgageScreens = {
  PointsToCashForMortgage: PointsToCashForMortgageScreen,
  DestinationAccountSelector: DestinationAccountSelectorScreen,
  RedemptionConfirmation: RedemptionConfirmationScreen,
  SuccessConfirmation: SuccessConfirmationScreen,
  MortgageAddressSelector: MortgageAddressSelectorScreen,
  MortgageAddress: MortgageAddressScreen,
}
